import { z } from "zod";
import { MediaSchema } from "../../fragments";
export const RiftboundPlaceholdersSchema = z.object({
    cardImage: MediaSchema.optional(),
});
//# sourceMappingURL=placeholders.js.map